module.exports = "https://cdn.littlereply.com/tt/resource/double@3x.900926b5c3e2e799bb8e5fbcfa9a5b65.png";